<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>收款日期:</label>
            <timeStampDatePicker  v-model='query.startTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>至</label>
            <timeStampDatePicker  v-model='query.endTime' class="item"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix" ></goodsSearchItem>
            <!-- <label>商品编码:</label>
            <lk-input clearable v-model='query.goodsSerialCode' class="item" placeholder="请输入"></lk-input> -->
          </div>
          <!-- <div class="queryItem">
            <label>商品通用名称</label>
            <goodsSelect  class="item"
              v-model="query.goodsBaseIdList"></goodsSelect>

          </div> -->
           <div class="queryItem">
            <label>商品分类:</label>
            <div class="item">
              <TreeSelect v-model.trim="query.categoryIdList" :data="indicationTree" :props="{title: 'label', value: 'value', children: 'children'}"></TreeSelect>
            </div>
         </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.labelIdList' class="item" clearable multiple >
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false,getTotal)">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap btn">
          <exportAsync class="mr" v-if="handlePermission('retailDecisionAnalysisByDayExport')" @on-click='handleExport'></exportAsync>
          <lk-button type="primary" class="mr" @click='refreshTime'>刷新今日报表</lk-button>
          <div v-if="deadline">数据截止至 {{deadline}}</div>
        </div>
        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">数量:</div>
            <div class="Report-total-item-value">{{total.numStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税应收额:</div>
            <div class="Report-total-item-value">{{total.retailAmountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税实收额:</div>
            <div class="Report-total-item-value">{{total.amountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">销售税额:</div>
            <div class="Report-total-item-value">{{total.taxAmountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税实收额:</div>
            <div class="Report-total-item-value">{{total.amountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税成本:</div>
            <div class="Report-total-item-value">{{total.costAmountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税成本:</div>
            <div class="Report-total-item-value">{{total.costAmountWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税毛利:</div>
            <div class="Report-total-item-value">{{total.profitStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">含税毛利率:</div>
            <div class="Report-total-item-value">{{total.profitRateStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税毛利:</div>
            <div class="Report-total-item-value">{{total.profitWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税毛利率:</div>
            <div class="Report-total-item-value">{{total.profitRateWithoutTaxStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">客流量:</div>
            <div class="Report-total-item-value">{{total.passengerFlow}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">平均客购买:</div>
            <div class="Report-total-item-value">{{total.avgBuyStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">平均品单价:</div>
            <div class="Report-total-item-value">{{total.avgGoodsPriceStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">平均客品数量:</div>
            <div class="Report-total-item-value">{{total.avgNumStr}}</div>
          </div>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import reportService from '@/services/report';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
// import goodsService from '@/services/goods';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import exportAsync from '../../components/report/ExportAsync.vue';
// import goodsSelect from '../../components/report/GoodsSelect.vue';
import reportMixin from './reportMixin.js';
import TreeSelect from '../../components/treeSelect/treeSelect.vue';

export default {
  name: 'retailDecisionAnalysisByDayList',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame, exportAsync, TreeSelect,
  },
  data() {
    return {
      query: {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        goodsSerialCode: '',
        storeIdList: [],
        goodsBaseIdList: [],
      },
      total: {},
      columns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '收款日期',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '业务机构',
          key: 'goodsStoreVoStoreCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'goodsStoreVoStoreName',
          minWidth: 116,
        },
        {
          title: '商品编码',
          key: 'goodsStoreVoGoodsSerialCode',
          minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'goodsStoreVoGoodsApprovedName',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'goodsStoreVoSpec',
          minWidth: 116,
        },
        {
          title: '生产企业',
          key: 'goodsStoreVoProducer',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'goodsStoreVoMinPkgUnitName',
          minWidth: 116,
        },
        {
          title: '零售价',
          key: 'retailPriceStr',
          minWidth: 116,
        },
        {
          title: '销项税率',
          key: 'outputTaxRateStr',
          minWidth: 116,
        },
        {
          title: '数量',
          key: 'numStr',
          minWidth: 116,
        },
        {
          title: '含税应收额',
          key: 'retailAmountStr',
          minWidth: 116,
        },
        {
          title: '含税实收额',
          key: 'amountStr',
          minWidth: 116,
        },
        {
          title: '销售税额',
          key: 'taxAmountStr',
          minWidth: 116,
        },
        {
          title: '不含税实收额',
          key: 'amountWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '含税成本',
          key: 'costAmountStr',
          minWidth: 116,
        },
        {
          title: '不含税成本',
          key: 'costAmountWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '含税毛利',
          key: 'profitStr',
          minWidth: 116,
        },
        {
          title: '含税毛利率',
          key: 'profitRateStr',
          minWidth: 116,
        },
        {
          title: '不含税毛利',
          key: 'profitWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '不含税毛利率',
          key: 'profitRateWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '客流量',
          key: 'passengerFlow',
          minWidth: 116,
        },
        {
          title: '平均客购买',
          key: 'avgBuyStr',
          minWidth: 116,
        },
        {
          title: '平均品单价',
          key: 'avgGoodsPriceStr',
          minWidth: 116,
        },
        {
          title: '不含税毛利占比',
          key: 'profitWithoutTaxRatio',
          minWidth: 116,
        },
        {
          title: '不含税实收额占比',
          key: 'amountWithoutTaxRatio',
          minWidth: 116,
        },
        {
          title: '平均客品数量',
          key: 'avgNumStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      goodsLoading: false,
      goodsList: [],
    };
  },
  methods: {
    handleExport(info, func) {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      this.$store.commit('setDisableLoading', true);
      reportService.retailDecisionAnalysisByDayExport(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getTotal() {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      reportService.retailDecisionAnalysisByDayTotal(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          this.total = res.data.data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
    // fetchGoods(query) {
    //   if (query !== '') {
    //     const data = {
    //       nameMix: query,
    //       page: 1,
    //       size: 5,
    //     };
    //     this.goodsLoading = true;
    //     this.$store.commit('setDisableLoading', true);
    //     goodsService.listGoodsBases(data).then((res) => {
    //       if (res.data.status === 200) {
    //         this.goodsList = res.data.data.list;
    //       } else {
    //         this.$Message.error(res.data.error);
    //       }
    //       this.goodsLoading = false;
    //     }).catch((err) => {
    //       utils.handleError(err);
    //     });
    //   } else {
    //     this.goodsList = [];
    //   }
    // },
    clear() {
      this.query = {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        goodsSerialCode: '',
        storeIdList: [],
        goodsBaseIdList: [],
      };
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();

      reportService.retailDecisionAnalysisByDay(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.createTime = result.createTime ? utils.formatTime(result.createTime, 'YYYY-MM-DD') : '';
            this.tableData.push(result);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.fetchListIndications();
    this.getLabel();
    this.handleSearch(true, this.getTotal);
    this.getRefreshTime();
  },
};
</script>
<style lang="less" scoped>
  .btn{
    margin-bottom: 12px
  }
</style>
